import { KomboRejectionReason } from "./kombo_rejection_reason";

export class KomboRejectionReasons extends Array<KomboRejectionReason> {
  constructor(rejectionReasons?: KomboRejectionReason[]) {
    super();
    if (rejectionReasons instanceof Array)
      rejectionReasons.forEach((rejectionReason) => this.push(rejectionReason));
  }
}
